import { h, Component, Fragment, toChildArray } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../config";

import PFeed from "../../../services/prematch-feed";
import { compareTwoStrings, diceSimilarity, similarity } from "../utils/strings-similarity";
import DatalistInput from "../utils/datalist-input";
import { PopupLink } from "../utils/popups";
import Ticket from "../utils/ticket-logic";

import * as W from "../desktop-templates/prematch-events-widget.jsx";
import * as I from "../utils/icons";
import { useEffect, useRef, useState } from "preact/hooks";


export default function PrematchQuickbet() {
	return <PrematchQuickbetContents addToBetslipCallback={outcome => Ticket.addFastbetOdds(outcome)} />;
}

function CurrentEventInfo({ event, market, onCancel }) {
	// TODO aggiungere qualcosa che mi fa inviare la quota al ticket (listener su INVIO?)
	return <W.CurrentEventRow>
		<W.CancelSelection onClick={onCancel} />
		<W.CurrentEventName>{event.team_casa}{!!event.team_ospite ? " - " + event.team_ospite : ""}</W.CurrentEventName>
		{!!market && (
			<W.CurrentMarketRow>
				{market.label} &raquo;{" "}<W.Highlight>{market.odds}</W.Highlight>
			</W.CurrentMarketRow>
		)}
	</W.CurrentEventRow>
}

// mappa ad oggetto da usare in Ticket.addFastbetOdds(obj)
const asTicketReady = (selectedEvent, selectedMarket) => {
	return {
		code: selectedMarket.code,
		campionato: selectedEvent.desc_sport + " - " + selectedEvent.desc_palinsesto + " - " + selectedEvent.desc_manifestazione,
		codice: selectedEvent.indice_ricerca,
		data_evento: new Date(selectedEvent.data_evento_ts).toISOString(),
		evento: selectedEvent.team_casa + (!!selectedEvent.team_ospite ? " - " + selectedEvent.team_ospite : ""),
		legatura: selectedMarket.bindings,
		manifestazione: parseInt(selectedEvent.manifestazione),
		quota: parseFloat(selectedMarket.odds),
		scommessa: selectedMarket.marketname,
		esito: selectedMarket.outcomename,
		segno: selectedMarket.outcomename,
		speciale: selectedMarket.special,
		sport: parseInt(selectedEvent.sport),
		eventlimit: null,
		idevents: selectedMarket.idevents,
		sportid: parseInt(selectedEvent.sport),
		tournamentid: parseInt(selectedEvent.manifestazione),
	}
}

export function PrematchQuickbetContents({ addToBetslipCallback }) {
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [selectedMarket, setSelectedMarket] = useState(null);

	const reset = () => {
		setSelectedEvent(null);
		setSelectedMarket(null);
	}

	const completeAddToTicket = () => {
		if (!!selectedEvent && !!selectedMarket) {
			addToBetslipCallback(asTicketReady(selectedEvent, selectedMarket));
			reset();
			window.document.getElementById("qb-input-match").focus()
		}
	}

	const onEnter = (event) => {
		if (event.key == 'Enter')
			completeAddToTicket();
		if (event.key == 'Escape')
			reset();
	}

	useEffect(() => {
		window.addEventListener('keydown', onEnter)
		return () => window.removeEventListener('keydown', onEnter);
	}, [onEnter]);

	// TODO capire come cazzo devo fare per inviare la quota al ticket (CurrentEventInfo con autofocus)
	// TODO In ogni momento se premono ESC deve resettare il form

	return <W.QuickbetPanel>
		<W.QuickbetHeader>
			<W.Title><Trans>Scommessa Rapida</Trans></W.Title>
			<W.QbetBadge>
				<W.QbetLink onClick={(e) => PopupLink(Config.softionAPI + "/home/codiciesiti/")}>
					<Trans>QBET</Trans> <I.SearchIcon class="h-4 inline-block" />
				</W.QbetLink>
			</W.QbetBadge>
		</W.QuickbetHeader>
		<W.QuickbetForm id="quickbet-form" onSubmit={(e) => e.preventDefault()}>
			{!!selectedEvent && <CurrentEventInfo event={selectedEvent} market={selectedMarket} onCancel={e => reset()} />}
			<W.QuickbetInputs>
				<EventSearchbox key={selectedEvent && selectedEvent.evento} setSelectedEvent={setSelectedEvent} selectedEvent={selectedEvent} />
				<MarketSearchbox 
					key={(selectedEvent && selectedEvent.evento) + (selectedMarket && selectedMarket.code)} 
					focused={!!selectedEvent} 
					disabled={!selectedEvent}
					selectedEvent={selectedEvent} 
					selectedMarket={selectedMarket}
					setSelectedMarket={setSelectedMarket}
				/>
			</W.QuickbetInputs>
		</W.QuickbetForm>
	</W.QuickbetPanel>
}

export function EventSearchbox({ setSelectedEvent, selectedEvent }) {
	const [inputVal, setInputVal] = useState(() => !selectedEvent ? null : selectedEvent.indice_ricerca);
	const [interacting, setInteracting] = useState(false);
	const [listElements, setListElements] = useState([]);

	const performSearch = (searchstring) => {
		setInputVal(searchstring);

		if (!searchstring || !searchstring.trim()) {
			setInteracting(false);
			setListElements([]);
			return;
		}

		setInteracting(true);
		PFeed.searchEvent(searchstring, (results) => {
			if (!!results) {
				setListElements(sortSearchResultsBySimilarity(results, searchstring));
			} else {
				setListElements([]);
			}
		});
	}

	return <div class="main-content-form-element text-sm block w-2/5 relative">
		<input 
			value={inputVal} 
			id="qb-input-match"
			onInput={e => performSearch(e.target.value)} 
			class="main-content-form-element text-sm block w-full border border-harifzinc-950  p-1 bg-harif-900  focus:outline-none focus:border-custom-orange focus:ring-1 focus:ring-custom-orange"
			placeholder="Event Code" 
		/>
		{!interacting ? null : (<div class="absolute w-64 left-0 top-full bg-slate-100 max-h-60 overflow-y-auto">
			<ListElements
				list={listElements}
				empty={<div class="py-1 text-center text-slate-300"><Trans>No result</Trans></div>}
				key={inputVal}
				onEnter={setSelectedEvent}
			>
				{(event, selected) => <W.MatchEntry onClick={(e) => setSelectedEvent(event)} active={selected}>
					<W.MatchEntryTopRow>
						<W.EntryMatchName>{event.team_casa}{!!event.team_ospite ? " - " + event.team_ospite : ""}</W.EntryMatchName>
					</W.MatchEntryTopRow>
					<W.MatchEntryBottomRow>
						<W.MatchTournament>{event.desc_sport} &raquo; {event.desc_palinsesto} &raquo; {event.desc_manifestazione}</W.MatchTournament>
						<W.DashSeparator />
						<W.MatchDate>{localDateFormat(event.data_evento_ts)}</W.MatchDate>
					</W.MatchEntryBottomRow>
				</W.MatchEntry>}
			</ListElements>
		</div>)}
	</div>
}

export function ListElements({ list, empty, children, onEnter }) {
	const li = toChildArray(children);
	const [currentIdx, setCurrentIdx] = useState(0);

	// TODO navigazione da tastiera, se registri un {INVIO} seleziona questo elemento
	// TODO se cliccano fuori dalla lista => onEnter(null)

	const onKey = (event) => {
		if (event.key == 'ArrowUp') {
			event.preventDefault();
			let idx = (currentIdx - 1 + list.length) % list.length;
			setCurrentIdx(idx);
		}
		if (event.key == 'ArrowDown') {
			event.preventDefault();
			let idx = (currentIdx + 1) % list.length;
			setCurrentIdx(idx);
		}
		if (event.key == 'Enter' || (event.key == 'Tab' && !event.shiftKey)) {
			onEnter(list[currentIdx]);
		}
	}

	useEffect(() => {
		window.addEventListener('keydown', onKey)
		return () => window.removeEventListener('keydown', onKey);
	}, [onKey]);

	return <>
		{list.length == 0 && empty}
		{list.map((element, idx) => li[0] && li[0](element, idx == currentIdx))}
	</>
}

export function MarketSearchbox({ setSelectedMarket, selectedMarket, selectedEvent, focused, disabled }) {
	const [inputVal, setInputVal] = useState(() => !selectedMarket ? null : (selectedMarket.value || selectedMarket.label));
	const [interacting, setInteracting] = useState(false);
	const [startFocus] = useState(focused && !selectedMarket);

	const [fullList, setFullList] = useState([]);
	const [listElements, setListElements] = useState([]);

	const performSearch = (searchstring) => {
		setInputVal(searchstring);

		if (!searchstring || !searchstring.trim()) {
			setInteracting(false);
			setListElements([]);
			return;
		}

		setInteracting(true);
		setListElements(filterMarkets(fullList, searchstring));
	}

	useEffect(() => {
		if (!selectedEvent)
			return;
		PFeed.getEventMarkets(selectedEvent.indice_ricerca, (response) => {
			setFullList(marketDatalistFormat(!!response.scommesse ? response.scommesse : {}))
		});
	}, []);

	useEffect(() => {
		if (!startFocus)
			return;
		performSearch(inputVal);
	}, [fullList]);

	useEffect(() => {
		if (startFocus)
			window.document.getElementById("qb-market-input").focus()
	}, [startFocus]);

	return <div class="block w-3/5 relative">
		<input 
			id="qb-market-input"
			value={inputVal}
			onInput={e => performSearch(e.target.value)}
			class="fn-inputclass text-sm block w-full border border-harifzinc-950 p-1 bg-harif-900 "
			placeholder="..."
			autocomplete="off"
			disabled={disabled}
		/>
		{!interacting ? null : (<div class="absolute w-64 right-0 top-full bg-slate-100 max-h-60 overflow-y-auto">
			<ListElements
				list={listElements}
				empty={<div class="py-1 text-center text-slate-300"><Trans>No result</Trans></div>}
				key={inputVal}
				onEnter={setSelectedMarket}
			>
				{(item, selected) => <MarketListElement market={item}
					selected={selected}
					setSelectedMarket={setSelectedMarket} 
				/>}
			</ListElements>
		</div>)}
	</div>
}

export function MarketListElement({market, selected, setSelectedMarket}) {
	const self = useRef();
	useEffect(() => {
		if (selected)
			self.current.scrollIntoView(false);
	}, [selected]);

	return <a
		ref={self}
		href="javascript:void(0);"
		data-selected={selected}
		class={'block px-3 py-2 font-normal border-b data-[selected=true]:border-2 data-[selected=true]:border-red-500'}
		onClick={e => setSelectedMarket(market)}
	>
		{market.label}
	</a>
}

const sortSearchResultsBySimilarity = (results, searchstring) => {
	results.map((item) => {
		//> Se la ricerca è parziale, prendo il risultato migliore comparando i team separatamente
		if (searchstring.indexOf(" - ") === -1) {
			//> Team Ospite comparo solo se esiste
			const tAwayIndex = !!item.team_ospite
				? similarity(searchstring, item.team_ospite.replace(/\([^)]*\)/gs, "").trim())
				: 0;

			//> Team Casa
			const tHomeIndex = similarity(searchstring, item.team_casa.replace(/\([^)]*\)/gs, "").trim());

			//> Prendo il match migliore con la mia stringa di input
			item.matchindex = Math.floor((tHomeIndex > tAwayIndex ? tHomeIndex : tAwayIndex) * 100);

			//> Mi hanno indicato il nome completo di un evento, devo fare la ricerca sul nome intero
		} else {
			const eventFullName =
				item.team_casa.replace(/\([^)]*\)/gs, "").trim() +
				(!!item.team_ospite ? " - " + item.team_ospite.replace(/\([^)]*\)/gs, "").trim() : "");
			item.matchindex = Math.floor(similarity(searchstring, eventFullName) * 100);
		}

		return item;
	});

	return results.sort((a, b) => b.matchindex - a.matchindex);
}

function localDateFormat(timestamp) {
	const d = new Date(timestamp * 1000);
	return (
		d.toLocaleDateString(undefined, { month: "short", day: "2-digit" }) +
		" " +
		d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
	);
}

const marketDatalistFormat = (markets) => {
	return Object.values(markets).map((market) => {
		const outcome = market[0].split("~");
		return {
			label: outcome[3] + " » " + outcome[5],
			value: market[1].split("-").slice(2).join("."),
			qbetcode: market[2],
			odds: outcome[2],
			code: market[1],
			marketname: outcome[3],
			outcomename: outcome[5],
			bindings: market[3],
			special: market[4],
			idevents: market[5],
		};
	});
}

function filterMarkets(list_any, inputvalue) {
	const list = list_any.map(val => !!val.value ? val : {value: val, label: val})

	if (inputvalue === '') {
		return list.slice(0, 50).map(item => {
			if (!item.label) {
				item.label = item.value;
			}
			item.matchpercentage = 0;
			return item;
		});
	}

	const lowerinputvalue = inputvalue.toLowerCase();
	const terms = lowerinputvalue.split(' ');
	const marketCode = inputvalue;
	const qbetCode = inputvalue;

	//> Cerco di velocizzare disperatamente la ricerca cercando almeno una porzione del testo nel mercato
	let results = [];
	const preFilteredList = list.filter(item => {
		const label = !!item.label ? item.label : item.value;
		if (item.qbetcode && qbetCode.length <= item.qbetcode && item.qbetcode.indexOf(qbetCode) == 0)
			return true;
		if (item.value && item.value.indexOf(marketCode) >= 0)
			return true;
		return terms.some(term => label.toLowerCase().indexOf(term) !== -1);
	});

	for (let i = 0; i < preFilteredList.length; ++i) {
		const item = preFilteredList[i];
		item.matchpercentage = 0;

		let rating = {};

		if (!item.label) {
			item.label = item.value;
		}
		if (!!item.qbetcode && qbetCode.length <= item.qbetcode && item.qbetcode.indexOf(qbetCode) == 0) {
			item.matchpercentage = diceSimilarity(item.qbetcode, qbetCode, 2, true) * 100;
		}
		if (!!item.value && item.value.indexOf(marketCode) >= 0) {
			item.matchpercentage = 0.90 * diceSimilarity(item.value, marketCode, 2, true) * 100;
		}
		item.matchpercentage = item.matchpercentage || (
			inputvalue == item.value || inputvalue == item.label
				? 100
				: parseInt(0.5 * diceSimilarity(item.label.toLowerCase(), lowerinputvalue) * 100));

		/*if (item.matchpercentage === 100) {
			return [item];
		}*/

		results.push(item);
	}

	return results.sort((a, b) => b.matchpercentage - a.matchpercentage);
}